/**
 *
 * Asynchronously loads the component for TextContent
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TextContent = lazyLoad(
  () => import('./index'),
  module => module.TextContent,
);
